export default __webpack_public_path__ + "static/media/O-115.bfe81036.png";